import { collection, doc, getDocs } from 'firebase/firestore';
import { Laundry, LaundryCategory } from '../../entities';
import { Collections, db } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';

export const useCategories = (laundryId: string) => {
  const laundriesCollection = collection(db, Collections.Laundries).withConverter(converterOf(Laundry));
  const laundryDoc = doc(laundriesCollection, laundryId);
  const categoriesCollection = collection(laundryDoc, Collections.LaundryCategories).withConverter(
    converterOf(LaundryCategory)
  );

  const fetchAll = async (): Promise<LaundryCategory[]> => {
    const categoriesDoc = await getDocs(categoriesCollection);

    return categoriesDoc.docs.map((garmentDoc) => garmentDoc.data());
  };

  return {
    fetchAll,
  };
};

export default useCategories;
